<template>
  <div class="typeNav">
    <div class="typeNav_box">
      <ul>
        <li class="typeNav_item">
          <a href="http://cce.scu.edu.cn/">首页</a>
        </li>
        <li
          class="typeNav_item"
          v-for="(item, index) in systemNameList"
          :key="item.id"
          @click="goSystem(item)"
        >
          <a href="javascript:;">{{ item.sys_name }}</a>
        </li>
      </ul>
    </div>

    <el-dialog
      title="请选择系统"
      :visible.sync="systemDialogVisible"
      :modal="false"
      width="30%"
      center
      class="dialog-mask"
    >
      <div style="text-align: center;">
        <el-radio
          v-model="systemType"
          label="学位外语报名"
          border
          @change="changeSystemType"
          >学位外语报名</el-radio
        >
        <el-radio
          v-model="systemType"
          label="学位申请"
          border
          @change="changeSystemType"
          >学位申请</el-radio
        >
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="goNextSys">确 定</el-button>
        <el-button @click="systemDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { systemInfo } from "@/api/api2";
export default {
  name: "typeNav",
  data() {
    return {
      systemNameList: [],
      //控制头部学位外语报名、学位申请系统对话框是否显示
      systemDialogVisible: false,
      systemType: "",
      selectSystemName: "",
      userInfo: {},
      xwwyItem: {},
      // 没有登录时点击头部学位外语报名、学位申请时的一个标识
      xyww_flag: false,
    };
  },
  created() {
    systemInfo().then((res) => {
      // console.log("顶部导航", res.result);
      this.systemNameList = res.result;
    });
  },
  methods: {
    goSystem(item) {
      console.log(11, item);
      let sys_id = item.id;
      this.xwwyItem = item;
      let { log_address_student, log_address_teacher, sys_address } = item;
      let userIf = JSON.parse(sessionStorage.getItem("userInfo"));
      // 没有登录
      if (!userIf) {
        if (sys_id == 6) {
          this.xyww_flag = true;
          this.systemDialogVisible = true;
          return false;
        }
        window.open(item.sys_address);
        return false;
      }
      this.userInfo = userIf;
      //招生系统
      if (sys_id == 1) {
        if (userIf.role == 1) {
          window.open(log_address_student);
        }
        if (userIf.role == 2) {
          // window.open(log_address_teacher + `?loginname=${userIf.v_name}`);
           let params012={
            loginname:userIf.v_name
          }
          this.openPostWindow(log_address_teacher,params012);
        }
      }

      //高教通-课程学习
      if (sys_id == 2) {
        if (userIf.role == 1) {
          window.open(
            log_address_student +
              `?v_xs_xm=${userIf.v_xs_xm}&v_xs_bm=${userIf.v_xs_bm}&type=1`
          );
        }
        if (userIf.role == 2) {
          window.open(log_address_teacher + `?account=${userIf.v_name}&type=2`);
        }
      }

      //省考过考
      if (sys_id == 3) {
        window.open(sys_address);
        return false;
      }

      //英语听说
      if (sys_id == 4) {
        if (userIf.role == 1) {
          // window.open(
          //   log_address_student +
          //     `?xsxm=${userIf.v_xs_xm}&xsbm=${userIf.v_xs_bm}`
          // );
           let params041={
            xsxm:userIf.v_xs_xm,
            xsbm:userIf.v_xs_bm
          }
          this.openPostWindow(log_address_student,params041);
        }
        if (userIf.role == 2) {
          // window.open(log_address_teacher + `?loginname=${userIf.v_name}`);
          let params042={
            loginname:userIf.v_name
          }
          this.openPostWindow(log_address_teacher,params042);
        }
      }

      //毕业论文
      if (sys_id == 5) {
        if (userIf.role == 1) {
          // window.open(
          //   log_address_student +
          //     `?xsxm=${userIf.v_xs_xm}&xsbm=${userIf.v_xs_bm}`
          // );
          let params051={
            xsxm:userIf.v_xs_xm,
            xsbm:userIf.v_xs_bm
          }
          this.openPostWindow(log_address_student,params051);
        }
        if (userIf.role == 2) {
          // window.open(log_address_teacher + `?loginname=${userIf.v_name}`);
          let params052={
            loginname:userIf.v_name
          }
          this.openPostWindow(log_address_teacher,params052);
        }
      }

      //学位外语报名、学位申请
      if (sys_id == 6) {
        this.systemDialogVisible = true;
      }

      //毕业办理
      if (sys_id == 7) {
        window.open(sys_address);
        return false;
      }

      //财务系统
      if (sys_id == 8) {
        if (userIf.role == 1) {
          this.$message.error("无权限跳转");
        }
        if (userIf.role == 2) {
          // window.open(log_address_teacher + `?loginname=${userIf.v_name}`);
          let params082={
            loginname:userIf.v_name
          }
          this.openPostWindow(log_address_teacher,params082);
        }
      }

      //ZC系统
      if (sys_id == 9) {
        if (userIf.role == 1) {
          // window.open(
          //   log_address_student +
          //     `?xsxm=${userIf.v_xs_xm}&xsbm=${userIf.v_xs_bm}`
          // );
          let params091={
            xsxm:userIf.v_xs_xm,
            xsbm:userIf.v_xs_bm
          }
          this.openPostWindow(log_address_student,params091);
        }
        if (userIf.role == 2) {
          // window.open(log_address_teacher + `?loginname=${userIf.v_name}`);
          let params092={
            loginname:userIf.v_name
          }
          this.openPostWindow(log_address_teacher,params092);
        }
      }
    },

    changeSystemType(value) {
      this.selectSystemName = value;
    },

    goNextSys() {
      let { log_address_student, log_address_teacher, sys_address } =this.xwwyItem;

      if (this.xyww_flag) {
        if (this.selectSystemName == "学位外语报名") {
          window.open(sys_address);
        }
        if (this.selectSystemName == "学位申请") {
          window.open("http://202.115.44.69:97");
        }
        this.systemDialogVisible = false;
        this.xyww_flag = false;
        return false;
      }

      if (this.userInfo.role == 1) {
        if (this.selectSystemName == "学位外语报名") {
          window.open(
            log_address_student +
              `?xsXm=${this.userInfo.v_xs_xm}&xsBm=${this.userInfo.v_xs_bm}&schoolId=0101&type=1`
            // "http://xwwytest.028zk01.net/pages/index.html?xsXm=" +
            //   this.userInfo.v_xs_xm +
            //   "&xsBm=" +
            //   this.userInfo.v_xs_bm +
            //   "&schoolId=0101&type=1"
          );
          this.systemDialogVisible = false;
        } else if (this.selectSystemName == "学位申请") {
          // window.open(
          //   // log_address_student+`?xsxm=${this.userInfo.v_xs_xm}&xsbm=${this.userInfo.v_xs_bm}`
          //   "http://202.115.44.69:97/StuSingleLogin.aspx?xsxm=" +
          //     this.userInfo.v_xs_xm +
          //     "&xsbm=" +
          //     this.userInfo.v_xs_bm +
          //     ""
          // );
          let paramsXwsq061={
            xsxm:this.userInfo.v_xs_xm,
            xsbm:this.userInfo.v_xs_bm
          }
          this.openPostWindow("http://202.115.44.69:97/StuSingleLogin.aspx",paramsXwsq061);
          this.systemDialogVisible = false;
        } else {
          this.$message.error("请选择一项系统名称");
        }
      }
      if (this.userInfo.role == 2) {
        if (this.selectSystemName == "学位外语报名") {
          window.open(
            log_address_teacher + `?name=${this.userInfo.v_name}&type=2`
            // "http://xwwytest.028zk01.net/pages/index.html?name=" +
            //   this.userInfo.v_name+"&type=2";
          );
          //  let paramsXwwybm092={
          //   loginname:this.userInfo.v_name
          // }
          // this.openPostWindow("http://202.115.44.69:97/singleLogin.aspx",paramsXwwybm092);
          this.systemDialogVisible = false;
        } else if (this.selectSystemName == "学位申请") {
          // window.open(
          //   // log_address_teacher+`?loginname=${this.userInfo.v_name}`
          //   "http://202.115.44.69:97/singleLogin.aspx?loginname=" +
          //     this.userInfo.v_name +
          //     ""
          // );
          let paramsXwwybm062={
            loginname:this.userInfo.v_name
          }
          this.openPostWindow("http://202.115.44.69:97/singleLogin.aspx",paramsXwwybm062);
          this.systemDialogVisible = false;
        } else {
          this.$message.error("请选择一项系统名称");
        }
      }

      // if (this.xyww_flag) {
      //   if (this.selectSystemName == "学位外语报名") {
      //     window.open(sys_address);
      //     this.systemDialogVisible = false;
      //   }else if (this.selectSystemName == "学位申请") {
      //     window.open("http://202.115.44.69:97");
      //     this.systemDialogVisible = false;
      //   }else{
      //     this.$message.error("请选择一项系统名称");
      //   }
      //   return false;
      // }
    },
    //使用post方式提交表单，跳转页面
    openPostWindow(url, targetObj) {
      var form = document.createElement('form');
      form.style = 'display:none';
      form.method = 'post';
      form.target = '_blank';
      form.action = url;
      for (let key in targetObj) {
        let input ="input"+Math.random();
        input= this.creatInput(key,targetObj[key]);
        form.appendChild(input);
      }
      document.body.appendChild(form);
      setTimeout(()=>{
        form.submit();
        document.body.removeChild(form);
      },100)
    },
    //创建表单项
    creatInput(name,val){
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = val;
      return input;
    }
  },
};
</script> 

<style scoped lang="scss">
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.typeNav {
  width: 100%;
  height: 50px;
  .typeNav_box {
    width: 1200px;
    height: 50px;
    margin: 0 auto;
    line-height: 50px;
    .typeNav_item {
      display: inline-block;
      padding-right: 24px;
      &:last-child {
        padding-right: 0;
      }
      a {
        font-size: 16px;
        color: #333;
        text-decoration: none;
        &::before {
          content: "";
          width: 4px;
          height: 4px;
          display: inline-block;
          margin-right: 6px;
          margin-bottom: 4px;
          // border-radius: 2px;
          background-color: #ccc;
        }
        &:hover {
          color: #ba2a17;
        }
      }
    }
  }
}
.dialog-mask {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
</style>
